import { defaultRoute, useBrowserRouterContext } from 'app/lib/contexts/KBrowserRouter'
import { useAppKeyboard } from 'app/lib/hooks/useAppKeyboard'
import React, { Fragment, useEffect } from 'react'
import { useLocation } from 'react-router'

import Menu from './Menu'

type Props = {
  selected?: string
}

const TabBar: React.FC<Props> = ({ selected }) => {
  const { visible } = useAppKeyboard()
  const { pathname } = useLocation()

  const { setBackRoute } = useBrowserRouterContext()

  useEffect(() => {
    setBackRoute(defaultRoute)
  }, [pathname])

  return (
    <If condition={!visible}>
      <Fragment>
        <div className="tab-bar">
          <Menu highlighted={[selected]} />
        </div>
        <div style={{ height: 65, width: '100%' }} />
      </Fragment>
    </If>
  )
}

export default TabBar
